import React from 'react';

const UserSquareIcon = ({
  width = '17',
  height = '17',
  fill = 'none',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 17"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    {...props}
  >
    <g opacity="0.5">
      <path
        d="M8.29745 8.65643C9.53827 8.65643 10.5441 7.65056 10.5441 6.40976C10.5441 5.16895 9.53827 4.16309 8.29745 4.16309C7.05666 4.16309 6.05078 5.16895 6.05078 6.40976C6.05078 7.65056 7.05666 8.65643 8.29745 8.65643Z"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7136 15.0216C12.7136 13.9247 12.2482 12.8727 11.4198 12.0971C10.5914 11.3215 9.4678 10.8857 8.29624 10.8857C7.1247 10.8857 6.00113 11.3215 5.17272 12.0971C4.3443 12.8727 3.87891 13.9247 3.87891 15.0216"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5251 1.57715H3.06808C2.24304 1.57715 1.57422 2.24597 1.57422 3.07101V13.528C1.57422 14.3531 2.24304 15.0219 3.06808 15.0219H13.5251C14.3501 15.0219 15.0189 14.3531 15.0189 13.528V3.07101C15.0189 2.24597 14.3501 1.57715 13.5251 1.57715Z"
        stroke="#222222"
        strokeWidth="1.65984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default UserSquareIcon;
